'use client';

import { c as _c } from "react/compiler-runtime";
import { PropsWithChildren } from 'react';
import { TanstackProvider } from '@repo/tanstack/provider';
export const SdkProvider = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <TanstackProvider data-sentry-element="TanstackProvider" data-sentry-component="SdkProvider" data-sentry-source-file="sdk-provider.tsx">{children}</TanstackProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};